import Vue from "vue";
import VueRouter from "vue-router";
import Index from "@/views/index/index.vue";
import CooperationJoin from "@/views/cooperation-join/index.vue";
import PrintCollege from "@/views/print/college/college.vue";
import PrintConvenience from "@/views/print/convenience/convenience.vue";
import PrintBox from "@/views/print/box/box.vue";
import AboutUs from "@/views/about-us/index.vue";
import ProductList from "@/views/product/list/list.vue";
import ProductDetail from "@/views/product/detail/detail.vue";
import FaqList from "@/views/faq/list/list.vue";
import FaqDetail from "@/views/faq/detail/detail.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
    meta: {
      title: "易可印",
    },
  },
  {
    path: "/index",
    redirect: "/",
  },
  {
    path: "/print/college",
    name: "PrintCollege",
    component: PrintCollege,
    meta: {
      title: "高校打印",
    },
  },
  {
    path: "/print/convenience",
    name: "PrintConvenience",
    component: PrintConvenience,
    meta: {
      title: "便民打印",
    },
  },
  {
    path: "/print/box",
    name: "PrintBox",
    component: PrintBox,
    meta: {
      title: "多拉宝盒",
    },
  },
  // 关于我们
  {
    path: "/about-us",
    name: "AboutUs",
    component: AboutUs,
    meta: {
      title: "关于我们",
    },
  },
  // 合作加盟
  {
    path: "/cooperation-join",
    name: "cooperation-join",
    component: CooperationJoin,
    meta: {
      title: "合作加盟",
    },
  },
  // 产品中心
  {
    path: "/product/list",
    name: "ProductList",
    component: ProductList,
    meta: {
      title: "产品中心",
    },
  },
  {
    path: "/product/detail",
    name: "ProductDetail",
    component: ProductDetail,
    meta: {
      title: "产品详情",
    },
  },
  // 常见问题
  {
    path: "/faq/list",
    name: "FaqList",
    component: FaqList,
    meta: {
      title: "常见问题",
    },
  },
  {
    path: "/faq/detail",
    name: "FaqDetail",
    component: FaqDetail,
    meta: {
      title: "详情-常见问题",
    },
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return {
      selector: "#app"
    };
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
